export function charColor(len: number, max: number): string {
  if (len > max) return 'var(--error)';
  if (len > max * 0.9) return 'var(--warning)';
  return 'var(--text-muted)';
}
